import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import useAuthStore from "@repo/core/stores/auth";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";

export const ProfileController = () => {
  const { back } = useNavigation();
  const { isMobile, isWeb } = useDimensions();

  const { user } = useAuthStore();
  const { selectedStore } = useStoresAndShopkeepersStore();

  return { back, isMobile, isWeb, selectedStore, user };
};
